import { render, staticRenderFns } from "./MaquinaCategoria.vue?vue&type=template&id=22e4f194&"
import script from "./MaquinaCategoria.vue?vue&type=script&lang=js&"
export * from "./MaquinaCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports